'use client';

import { Suspense } from 'react';

import { useHydration } from '@/server/hooks/useHydration';
import { formatMessageEventCardDates } from '@/ui/components/Event/utils/formatMessageEventCardDate';

import css from './Badges.module.scss';

type Props = {
  startTime: string;
  endTime: string;
};

const TimeDisplay = ({ startTime, endTime }: Props) => {
  // Always use formatMessageEventCardDates - it will use server timezone on server, client timezone on client
  const displayTime = formatMessageEventCardDates(startTime, endTime);

  return (
    <time dateTime={startTime}>
      <span style={{ whiteSpace: 'nowrap' }}>
        {displayTime.monthDay}
        <span className={css.datetime}>{displayTime.time}</span>
      </span>
    </time>
  );
};

export const DateTimeBadge = ({ startTime, endTime }: Props) => {
  const { suspenseKey } = useHydration();

  return (
    <>
      <dt>Date and Time</dt>
      <dd>
        <svg className={css.timeIcon}>
          <use href="#time-icon" />
        </svg>
        <Suspense key={suspenseKey} fallback={<span>Loading...</span>}>
          <TimeDisplay startTime={startTime} endTime={endTime} />
        </Suspense>
      </dd>
    </>
  );
};
